<div class="filtro-select-wrapper">
  <select
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
    [disabled]="disabled"
  >
    <option *ngIf="placeholder" [ngValue]="defaultValue">{{ placeholder }}</option>
    <option *ngFor="let option of options" [ngValue]="option.value">{{ option.label }}</option>
  </select>
</div>
